(() => {
  const productCache = new Map();
  const observed = new WeakSet();

  const normalize = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const escapeHTML = (value) => String(value).replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const colorStyle = (name) => {
    const value = normalize(name);
    if (value.includes('многоцвет') || value.includes('multi')) return 'conic-gradient(#5b1422,#c5a62d,#315f71,#5b1422)';
    const colors = [
      [['чер', 'black'], '#171717'], [['бял', 'white', 'ivory', 'екрю', 'ecru'], '#f6f0e3'],
      [['беж', 'beige', 'пяс', 'sand', 'cream', 'крем'], '#d9c7a5'], [['сив', 'gray', 'grey'], '#8b8b86'],
      [['каф', 'brown', 'camel', 'камел'], '#79553d'], [['черв', 'red'], '#b5232f'],
      [['бордо', 'burgundy', 'wine'], '#5b1422'], [['роз', 'pink', 'fuchsia'], '#d87391'],
      [['тъмносин', 'navy'], '#17253f'], [['син', 'blue'], '#315f91'], [['тюркоаз', 'turquoise'], '#3d9b9b'],
      [['зелен', 'green', 'khaki', 'каки'], '#567052'], [['жълт', 'yellow', 'горчи', 'mustard'], '#c5a62d'],
      [['оранж', 'orange'], '#d66b35'], [['лилав', 'purple', 'violet'], '#6d4b7e'],
      [['злат', 'gold'], '#b39235'], [['среб', 'silver'], '#b9b9b5']
    ];
    const match = colors.find(([keys]) => keys.some((key) => value.includes(key)));
    if (match) return match[1];
    if (window.CSS?.supports?.('color', value)) return value;
    return '#dedbd5';
  };

  const productFor = (path) => {
    if (!productCache.has(path)) productCache.set(path, fetch(`${path}.js`, { credentials: 'same-origin' }).then((response) => response.ok ? response.json() : null).catch(() => null));
    return productCache.get(path);
  };

  const enrich = async (card) => {
    if (card.dataset.sxtVariantsLoaded === 'true') return;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    const path = new URL(link.href, location.origin).pathname;
    const product = await productFor(path);
    if (!product || !Array.isArray(product.variants)) return;
    const optionNames = (product.options || []).map((option) => normalize(typeof option === 'string' ? option : option.name));
    const sizeIndex = optionNames.findIndex((name) => name.includes('size') || name.includes('размер'));
    const colorIndex = optionNames.findIndex((name) => name.includes('color') || name.includes('colour') || name.includes('цвят'));
    const available = product.variants.filter((variant) => variant.available);
    const unique = (index) => index < 0 ? [] : [...new Set(available.map((variant) => variant.options?.[index]).filter(Boolean))];
    const sizes = unique(sizeIndex);
    const colors = unique(colorIndex);
    card.dataset.sxtVariantsLoaded = 'true';
    if (!sizes.length && !colors.length) return;
    card.querySelectorAll('.sxt-card-availability,.sxt-v8-variants').forEach((element) => element.remove());
    const info = card.querySelector('.card-information__wrapper') || card.querySelector('.card-information');
    if (!info) return;
    const panel = document.createElement('div');
    panel.className = 'sxt-v8-variants';
    if (sizes.length) panel.innerHTML += `<div class="sxt-v8-sizes"><span>Налични размери</span><p>${sizes.slice(0, 9).map((size) => `<b>${escapeHTML(size)}</b>`).join('')}${sizes.length > 9 ? '<b>+</b>' : ''}</p></div>`;
    if (colors.length) panel.innerHTML += `<div class="sxt-v8-colors"><span>Цветове</span><p>${colors.slice(0, 8).map((color) => `<i title="${escapeHTML(color)}" aria-label="${escapeHTML(color)}" style="--sxt-card-color:${colorStyle(color)}"></i>`).join('')}</p></div>`;
    info.append(panel);
    card.querySelectorAll('.card__colors,color-swatch').forEach((element) => { element.style.display = 'none'; });
  };

  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { observer.unobserve(entry.target); enrich(entry.target); }
  }), { rootMargin: '500px 0px' });

  const discover = () => document.querySelectorAll('.card-wrapper').forEach((card) => {
    if (observed.has(card)) return;
    observed.add(card);
    observer.observe(card);
  });
  new MutationObserver(discover).observe(document.documentElement, { childList: true, subtree: true });
  discover();
})();
